import Dashboard from '../containers/dashboard'
import CustomerCompanyPaymentsManagement from '../containers/customer-company-payments-management'

const CustomerCompanyPayments = () => {
  return (
    <Dashboard>
      <CustomerCompanyPaymentsManagement />
    </Dashboard>
  )
}

export default CustomerCompanyPayments
